/* eslint-disable @typescript-eslint/no-explicit-any */
import { EMAIL_REGEX } from '../../../utils';

import type { NewsLetterProps } from './NewsLetter';

type NewsletterState = {
  checked: boolean;
  email: string;
  emailError: boolean;
  success: boolean;
  termsError: boolean;
  submitting: boolean;
  submitError: boolean;
};

type NewsletterAction =
  | {
      type:
        | 'SET_CHECKED'
        | 'SET_TERMS_ERROR'
        | 'SET_EMAIL_ERROR'
        | 'SET_SUCCESS'
        | 'SET_SUBMITTING'
        | 'SET_SUBMIT_ERROR';
      payload: boolean;
    }
  | {
      type: 'SET_EMAIL';
      payload: string;
    };

export const newsletterReducer = (state: NewsletterState, action: NewsletterAction) => {
  switch (action.type) {
    case 'SET_CHECKED':
      return {
        ...state,
        checked: action.payload,
      };
    case 'SET_TERMS_ERROR':
      return {
        ...state,
        termsError: action.payload,
      };
    case 'SET_EMAIL_ERROR':
      return {
        ...state,
        emailError: action.payload,
      };
    case 'SET_SUCCESS':
      return {
        ...state,
        success: action.payload,
      };
    case 'SET_EMAIL':
      return {
        ...state,
        email: action.payload,
      };
    case 'SET_SUBMITTING':
      return {
        ...state,
        submitting: action.payload,
      };
    case 'SET_SUBMIT_ERROR':
      return {
        ...state,
        submitError: action.payload,
      };
    default:
      return state;
  }
};

export const newsletterInitialState = {
  checked: false,
  email: '',
  emailError: false,
  submitError: false,
  submitting: false,
  success: false,
  termsError: false,
};

export const createNewsletterFormSubmitHandler =
  (
    newsletterState: any,
    dispatch: React.Dispatch<NewsletterAction>,
    handleNewsletterFormSubmission: (...args: any[]) => Promise<any>,
    locale: any,
    newsletter?: Omit<NewsLetterProps, 'submitHandler' | 'state' | 'setChecked' | 'setEmail'>,
  ) =>
  async (e: React.SyntheticEvent) => {
    e.preventDefault();
    dispatch({ payload: false, type: 'SET_SUBMIT_ERROR' });

    if (!EMAIL_REGEX.test(newsletterState.email) || newsletterState.email === '') {
      dispatch({ payload: '', type: 'SET_EMAIL' });
      dispatch({ payload: true, type: 'SET_EMAIL_ERROR' });
    } else {
      dispatch({ payload: false, type: 'SET_EMAIL_ERROR' });
    }

    if (!newsletterState.checked) {
      dispatch({ payload: true, type: 'SET_TERMS_ERROR' });
    } else {
      dispatch({ payload: false, type: 'SET_TERMS_ERROR' });
    }

    if (EMAIL_REGEX.test(newsletterState.email) && newsletterState.checked) {
      dispatch({ payload: true, type: 'SET_SUBMITTING' });
      try {
        const res = await handleNewsletterFormSubmission(
          newsletterState.email,
          'BE',
          locale.id,
          newsletter?.campaignName ?? '',
        );

        if (res === 200) {
          dispatch({ payload: '', type: 'SET_EMAIL' });
          dispatch({ payload: true, type: 'SET_SUCCESS' });
          dispatch({ payload: false, type: 'SET_SUBMIT_ERROR' });
        } else {
          dispatch({ payload: true, type: 'SET_SUBMIT_ERROR' });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        dispatch({ payload: true, type: 'SET_SUBMIT_ERROR' });
      } finally {
        dispatch({ payload: false, type: 'SET_SUBMITTING' });
      }
    }
  };
